import React from 'react';
import cx from 'classnames';

import styles from './ChartLoader.module.scss';

export const ChartLoader = () => (
  <div className={styles.loader} role='alert' aria-busy>
    <div className={styles.pulseContainer}>
      <div className={styles.pulse} />
      <div className={cx(styles.pulse, styles.secondPulse)} />
    </div>
  </div>
);
